import styled from 'styled-components'

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  justify-content: center;
  align-items:center;
  overflow:hidden;  

`
export const ContainerMessage = styled.span`
  text-align:center;
`
export const Video = styled.video`
  width: 100%;
`
export const SubContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: row;
  width: 100%;
`
